import styled from "styled-components";

const StyledSearchInput = styled.div<{ spacing?: number }>`
  position: relative;
  width: 100%;
  margin: ${({ spacing }) => (spacing ? spacing * 8 : 0)}px 0px;
`;

export default StyledSearchInput;
